import { Component, OnInit, OnDestroy, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from 'src/app/services/auth.service';
import { NgForm } from '@angular/forms';
import { AdditionalIncomeSource, AdditionalIncomeSourceType } from 'src/app/models/Argyle';
import { ApplicantDataService } from 'src/app/services/applicant-data.service';
import { Screening, ScreeningLight } from 'src/app/models/screeningInvite';
import { GroupApplicantsService } from 'src/app/services/group-applicants.service';
import { IncomeSourceModalComponent } from '../income-source-modal/income-source-modal.component';

@Component({
  selector: 'app-income-source-groups-modal',
  templateUrl: './income-source-groups-modal.component.html',
  styleUrls: ['./income-source-groups-modal.component.less']
})
export class IncomeSourceGroupsModalComponent { 
@ViewChild('incomeSrc', {}) ngForm: NgForm;
@Input() screening : ScreeningLight;
@Input() sourceTypes : any[];
saving : boolean = false;
@Input() newSource: AdditionalIncomeSource;
// @Input() groupscrns : Screening[];
@Output() public saved : EventEmitter<boolean> = new EventEmitter<boolean>();
private modalRef1: NgbModalRef | null = null;
constructor(public modalService: NgbModal, private toast: ToastrService, private auth: AuthService, public appData: ApplicantDataService,public groups: GroupApplicantsService) { }
ngOnDestroy(): void {
  // throw new Error("Method not implemented.");
}

ngOnInit(): void {
  // throw new Error("Method not implemented.");
  // loop over the other group memebers and get their income sources
  
}



public get groupscrns() : Screening[] {
  if(!this.groups.groupScreenings) return [];
  else return this.groups.groupScreenings;
}

addSource(scrn : Screening) {
  this.modalRef1 = this.modalService.open(IncomeSourceModalComponent, { centered: true, size: 'lg' })
  this.modalRef1.componentInstance.name = 'IncomeSourceModalComponent';
  this.modalRef1.componentInstance.screeningId = scrn.id;
  this.modalRef1.componentInstance.applicantName = `- ${scrn.firstName} ${scrn.lastName}`;
  this.modalRef1.componentInstance.sourceTypes = this.appData.incomeSourceTypes;
  this.modalRef1.componentInstance.showSnapptToggle = this.screening.billingRule;
  // this.modalRef1.componentInstance.newSource = src;
  // this.modalRef1.componentInstance.saved.subscribe((dta: boolean) => {
  //   this.loadSources();
  // });
  this.modalRef1.componentInstance.closed.subscribe((dta : boolean)=>{
    this.modalRef1.close();
    this.saved.emit();
  })
}


cancel(){
  this.modalService.dismissAll();
}

saveRule(){
  console.log(this.newSource);
  this.newSource.screeningId = this.screening.screeningId;
  this.saving = true;
  if(this.ngForm.status == 'VALID')
  {
    this.appData.SaveAdditionalIncomeSource(this.newSource).subscribe((scc: AdditionalIncomeSource)=>{
      this.newSource.id = scc.id;
      this.saved.emit(true);
      this.modalService.dismissAll();
    },(err: any)=>{
      this.toast.error('Error Saving Income Source');
    },()=> {
      this.saving = false;
    });
  }
}
}
